(ns ui.totp.generate
  "Client-side TOTP code generation using the otpauth npm package.
   Used to show a live OTP preview when the user enters a TOTP secret,
   so they can verify it in Instagram's 2FA setup flow."
  (:require ["otpauth" :as OTPAuth]
            [app.totp.validation :as validation]))

(def secret-key-length
  "Expected length of a base32-encoded TOTP secret key."
  validation/secret-key-length)

(def totp-period
  "TOTP time step in seconds (RFC 6238 standard)."
  validation/totp-period)

(defn generate-otp
  "Generates a 6-digit TOTP code from a base32 secret key.
   Returns the OTP string or nil if the secret is invalid."
  [secret-key]
  (try
    (let [totp (OTPAuth/TOTP. #js {:secret (OTPAuth/Secret.fromBase32 secret-key)
                                    :digits 6
                                    :period totp-period
                                    :algorithm "SHA1"})]
      (.generate totp))
    (catch :default _e
      nil)))

(defn seconds-remaining
  "Returns the number of seconds remaining in the current 30-second TOTP window.
   Accepts an optional clock-ms (e.g. from :ui/clock state) to stay in sync
   with Replicant's re-render cycle."
  ([]
   (seconds-remaining (.now js/Date)))
  ([clock-ms]
   (- totp-period (mod (quot clock-ms 1000) totp-period))))
